var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n        Reembolsos a Receber dos Clientes\n      ")]),_c('div',{staticClass:"card-body"},[_c('NRCustomersOpen')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }